import Link from "next/link";
import { useRouter } from "next/router";
import { gql, useQuery } from "@apollo/client";
import moment from "moment";

import PageHeader from "@/components/PageHeader";
import handleStaticProps from "src/lib/handle-static-props";
import Image from "@/components/Image";
import Seo from "@/components/seo";
import Loader from "@/components/common/Loader/Loader";

export async function getStaticProps({ params }) {
  const { data, result } = await handleStaticProps({
    pageQuery,
    variables: params ? { year: params.year, week: params.week } : {},
  });

  if (!data.topChart) return { notFound: true };
  return result;
}

function Topless39Page() {
  const router = useRouter();
  const { data } = useQuery(pageQuery, {
    variables: { year: router.query.year, week: router.query.week },
  });

  if (!data) return <Loader />;

  const { topChart, allTopCharts: charts } = data;

  return (
    <div className="container">
      <Seo
        title={`${moment(topChart.date).format("MMMM D, YYYY")} | Topless 39`}
      />
      <PageHeader>
        Top Charts - {moment(topChart.date).format("MMMM D, YYYY")}
      </PageHeader>
      <ul className="list-unstyled kvrx-charts">
        {topChart.albums.map((album) => (
          <li className="d-flex" key={album.id}>
            <div className="flex-shrink-0">
              <Image
                src={album.cover}
                width={100}
                height={100}
                alt={`${album.artist} - ${album.title} cover`}
                layout="fixed"
              />
            </div>
            <div className="flex-grow-1 ms-3 px-5 py-4">
              <p className="m-0">
                <i>{album.title}</i>
                <br />
                {album.artist}
                <br />
              </p>
              <p className="m-0 text-end">
                {album.url && (
                  <Link href={album.url}>
                    <a>
                      <span>READ REVIEW &gt;</span>
                    </a>
                  </Link>
                )}
              </p>
            </div>
          </li>
        ))}
      </ul>

      {charts.map((chart) => {
        const date = moment(chart.date);
        const year = date.year();
        const week = date.isoWeek();

        return (
          <p key={chart.id} className="text-center">
            <Link href={`/topless39/year/${year}/week/${week}/`}>
              <a>{date.format("MMMM D, YYYY")}</a>
            </Link>
          </p>
        );
      })}
    </div>
  );
}

export default Topless39Page;

const pageQuery = gql`
  query Topless39Page($year: Int, $week: Int) {
    topChart(year: $year, week: $week) {
      date
      albums {
        __typename
        id
        cover
        title
        artist
        url
      }
    }
    allTopCharts {
      __typename
      id
      date
    }
  }
`;

export { pageQuery };
